export const uploadState = {
  count: 0,
  uploading: false,
  controllers: null,
  status: null
};

export const UPLOAD_ACTIONS = Object.freeze({
  SETUP: "upload-status-setup",
  UPDATE_PROGRESS: "upload-status-update-progress",
  CANCEL_UPLOAD: "upload-status-cancel-upload",
  DECREASE: "upload-status-decrease",
  RESET: "upload-status-reset"
});

export const uploadReducer = (state, action) => {
  const { type, count, controllers, status } = action || {};
  switch (type) {
    case UPLOAD_ACTIONS.SETUP:
      return {
        ...state,
        count: state.count + count,
        uploading: !!(state.count + count),
        controllers: {
          ...state.controllers,
          ...controllers
        },
        status: {
          ...state.status,
          ...status
        }
      };
    case UPLOAD_ACTIONS.UPDATE_PROGRESS: {
      return {
        ...state,
        status: {
          ...state.status,
          ...status
        }
      };
    }
    case UPLOAD_ACTIONS.CANCEL_UPLOAD: {
      const { [status.name]: name, ...rest } = state.status;
      return {
        ...state,
        status: {
          ...rest
        }
      };
    }
    case UPLOAD_ACTIONS.DECREASE:
      return {
        ...state,
        count: state.count - 1,
        uploading: !!(state.count - 1)
      };
    case UPLOAD_ACTIONS.RESET:
      return uploadState;
    default:
      throw new Error();
  }
};
